// src/app/store.jsx
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import placementApi from './services/placementAPI';
import authAPI from './services/authAPI';
import commonAPI from './services/commonAPI';
import studentJobPostApi from './services/studentJobPostAPI';
import authReducer from './slice/authSlice';
import companyApi from './services/companyAPI';
import studentViewApi from './services/studentViewAPI';

import {
  menuAPI,
  profileAPI,
  contactUpdateAPI,
  CommonAPI,
  passwordVerificationAPI,
  NotificationAPI,
} from "@gyandiksha/shared-ui/app/services";


export const store = configureStore({
  reducer: {
    auth: authReducer,
    [placementApi.reducerPath]: placementApi.reducer,
    [companyApi.reducerPath]: companyApi.reducer,
    [studentViewApi.reducerPath]: studentViewApi.reducer,
    [authAPI.reducerPath]: authAPI.reducer,
    [commonAPI.reducerPath]: commonAPI.reducer,
    [studentJobPostApi.reducerPath]: studentJobPostApi.reducer,
    [profileAPI.reducerPath]: profileAPI.reducer,
    [contactUpdateAPI.reducerPath]: contactUpdateAPI.reducer,
    [CommonAPI.reducerPath]: CommonAPI.reducer,
    [menuAPI.reducerPath]: menuAPI.reducer,
    [passwordVerificationAPI.reducerPath]: passwordVerificationAPI.reducer,
    [NotificationAPI.reducerPath]: NotificationAPI.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      placementApi.middleware,
      companyApi.middleware,
      studentViewApi.middleware,
      authAPI.middleware,
      commonAPI.middleware,
      studentJobPostApi.middleware,
      profileAPI.middleware,
      contactUpdateAPI.middleware,
      CommonAPI.middleware,
      menuAPI.middleware,
      passwordVerificationAPI.middleware,
      NotificationAPI.middleware,
    ),
});

setupListeners(store.dispatch);
